class TabSection extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.tabs = this.querySelectorAll('.tab-pill');
    this.contents = this.querySelectorAll('.tab-content');
    this.images = this.querySelectorAll('.tab-image-content');
    this.featurePoints = this.querySelectorAll('.feature-point');
    this.tabContainer = this.querySelector('.tab-pills');
    
    this.setupTabIndicator();
    this.addTabListeners();
    this.addFeaturePointListeners();
  }

  setupTabIndicator() {
    if (!this.tabContainer) return;
    
    const tabCount = parseInt(this.tabContainer.dataset.tabCount) || 1;
    const tabWidth = 100 / tabCount;
    this.tabContainer.style.setProperty('--active-tab-width', `${tabWidth}%`);
  }

  addTabListeners() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.switchTab(tab));
    });
  }

  addFeaturePointListeners() {
    this.featurePoints.forEach(point => {
      const header = point.querySelector('.feature-point-header');
      const content = point.querySelector('.feature-point-content');
      
      if (header && content) {
        header.addEventListener('click', () => this.togglePoint(point, content));
      }
    });
  }

  switchTab(selectedTab) {
    // Remove active class from all tabs, contents and images
    this.tabs.forEach(tab => tab.classList.remove('active'));
    this.contents.forEach(content => content.classList.remove('active'));
    this.images.forEach(image => image.classList.remove('active'));
    
    // Add active class to selected tab, content and image
    selectedTab.classList.add('active');
    const selectedContent = this.querySelector(`[data-tab-content="${selectedTab.dataset.tab}"]`);
    const selectedImage = this.querySelector(`[data-tab-image="${selectedTab.dataset.tab}"]`);
    
    if (selectedContent) {
      selectedContent.classList.add('active');
    }
    if (selectedImage) {
      selectedImage.classList.add('active');
    }

    // Move the active indicator
    const tabIndex = parseInt(selectedTab.dataset.tabIndex) || 0;
    const tabWidth = selectedTab.offsetWidth;
    const position = tabWidth * tabIndex;
    this.tabContainer.style.setProperty('--active-tab-position', `${position}px`);
  }

  togglePoint(point, content) {
    const isActive = point.classList.contains('active');
    
    // Toggle active class
    point.classList.toggle('active');
    
    // Animate content height
    if (isActive) {
      content.style.maxHeight = '0';
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }
}

customElements.define('tab-section', TabSection); 